var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MembersPapers"}},[_c('div',[_c('div',[_c('h3',[_vm._v("Members' Papers")]),_c('hr'),_c('div',[_c('P',[_vm._v("Coming soon...")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }